import {_debug} from "../common/debugger/debugger";

export async function logoutDownloadAccess(url:string) {
  _debug("lb-frontend.logoutDownloadAccess() uri:", url);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": "true",
    },
    body: "", // body data type must match "Content-Type" header
  })

  _debug("lb-frontend.logoutDownloadAccess() processed with state:", response.status);
  return response.status;
}